<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Número Nota
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center"
                >
                  Data
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center"
                >
                  Vendedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center"
                >
                  Total
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center"
                >
                  Quantidade
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center"
                >
                  Saldo
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in manifestoSaida"
              :key="item.id"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nota }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.data }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.quantidade }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.saldo }}
                </td>
              </tr>
              <!-- Linha expandida -->
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id"
              >
                <td colspan="7">
                  <table
                    id="tableExpandida"
                    style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                  >
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center"
                        >
                          Número Nota
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Produto
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Total Venda
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Quant. Venda
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Total Manifesto
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Quant. Manifesto
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Saldo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(sub, idx) in item.dadosDetalheManifesto"
                        :key="idx"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ sub.nota }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ sub.produto }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.venda }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.quantidadeVenda }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.faturamento }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.quantidade }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.saldo }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Manifesto from '../../../../../services/manifesto'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowTableManifestoSaida',
    emits: [],
    components: {
      DashboardCoreSnackbar: () => import('../../core/Snackbar'),
    },
    data: () => ({
      styleObjectFaturamento: {
        color: '#4CAF50',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      vendedores: [],
      headersManifestoSaida: [
        { text: 'Número Nota', value: 'nota', align: 'left', class: 'black--text title' },
        { text: 'Data', value: 'data', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Total', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', align: 'right', class: 'black--text title' },
      ],
      headersDetalhesManifesto: [
        { text: 'Número Nota', value: 'nota', align: 'left', class: 'black--text title' },
        { text: 'Produto', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Total Venda', value: 'venda', align: 'right', class: 'black--text title' },
        { text: 'Quant. Venda', value: 'quantidadeVenda', align: 'right', class: 'black--text title' },
        { text: 'Total Manifesto', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Quant. Manifesto', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', align: 'right', class: 'black--text title' },
      ],
      manifestoSaida: [],
      expanded: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados-manifesto', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-manifesto', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, vendedores) {
        this.dataInicial = primeiroDia
        this.dataFinal = dataFinal
        this.vendedores = vendedores

        this.showDadosManifestoSaida()
      },

      async showDadosManifestoSaida () {
        this.loading = true

        this.manifestoSaida = []
        this.expanded = []

        await Manifesto.showManifestoSaida(this.dataInicial, this.dataFinal, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.manifestoSaida = resposta.data.dados.map((item) => {
              var listaFaturamento = ({
                nota: item.nota,
                data: item.data,
                vendedor: item.vendedor,
                faturamento: item.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                quantidade: item.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                saldo: item.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                expandir: item.expandir,
                dadosDetalheManifesto: this.orderDetalheManifesto(item.dadosManifestos),

              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Nao há dados disponíveis com filtros selecionados') {
            this.manifestoSaida = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Contrato não encontrado') {
            this.manifestoSaida = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data inicial não pode ser maior que a data Final') {
            this.manifestoSaida = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      orderDetalheManifesto (value) {
        const dadosManifestos = value.map((item) => {
          var listaDadosManifesto = ({
            nota: item.nota,
            produto: item.produto,
            faturamento: item.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            quantidade: item.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            saldo: item.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            venda: item.venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            quantidadeVenda: item.quantidadeVenda.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          })

          return listaDadosManifesto
        })

        return dadosManifestos
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 91vw !important;
      margin: 0 0 0 -1rem
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }
</style>

<style lang="sass">

</style>
